import { useState } from 'react';
import './inputFieldArea.scss';

interface IIinputField {
    value?: number | string;
    name: string;
    label: string;
    required?:boolean;
    disabled?:boolean;
    onChange?:any;
    error?:boolean;
    errorLabel?: string;
    style?:any;
    rows?:any;
    idLabel?: string;
    maxLength?: number;
}


export default function InputFieldArea({value, name, required, disabled, onChange, error, label, style, rows, errorLabel, idLabel, maxLength }:IIinputField) {
    const [ focused, setFocused ] = useState(false);

    return (
        <div className='input-field-area' style={{...style}}>
            <label htmlFor={idLabel ?? label}>{label} {required && <i className="icon-asterisk"/>}</label>
            <textarea
            id={idLabel ?? label}
            rows={Number(rows) || 1}
            name={name}
            value={value}
            maxLength={maxLength}
            className={`${error && '--error'} ${focused && '--focused'}`}
            onFocus={()=>setFocused(true)}
            onBlur={()=>setFocused(false)}
            onChange={(e)=> onChange && onChange(e)}
            disabled={disabled}
            autoComplete='off'
            />
            {errorLabel && <span className='error-label'>{errorLabel}</span>}
        </div>
    );
}
